import React from 'react';
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailShareButton,
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
  EmailIcon,
} from 'react-share';
import SocialShareWrapper from './SocialShare.style';

const SocialShare = ({ url, title }) => (
  <SocialShareWrapper className="social-share">
    <div className="story-wrap">
      <div className="title-area">
        <h4>Deel dit stuk op social media</h4>
      </div>
      <div className="social-networks">
        <FacebookShareButton quote={title} url={url}>
          <FacebookIcon
            size={50}
            round
            iconBgStyle={{ fill: '#FFF689' }}
            logoFillColor="#040404"
          />
        </FacebookShareButton>
        <TwitterShareButton title={title} url={url}>
          <TwitterIcon
            size={50}
            round
            iconBgStyle={{ fill: '#FFF689' }}
            logoFillColor="#040404"
          />
        </TwitterShareButton>
        <WhatsappShareButton title={title} separator=" – " url={url}>
          <WhatsappIcon
            size={50}
            round
            iconBgStyle={{ fill: '#FFF689' }}
            logoFillColor="#040404"
          />
        </WhatsappShareButton>
        <EmailShareButton
          subject={`Lees dit stuk van de NOV: ${title}`}
          url={url}
          body={url}
        >
          <EmailIcon size={50} round logoFillColor="#040404" />
        </EmailShareButton>
      </div>
    </div>
  </SocialShareWrapper>
);

export default SocialShare;
